const getStrokeColorForCircuralProgress = (usedTime) => {
  if (usedTime < 75) {
    return '#4F6C74';
  } else if (usedTime <= 100) {
    return '#FFD300';
  } else return '#BF0A30';
};

export default getStrokeColorForCircuralProgress;
